// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1ib7x","list":"PatternAutocomplete_list__21hX7"};